/**
 * @desc 阶段批量处理(通知调拨单发运时间,该阶段不在时效监控范围内ProcessPhaseEnum给NONE)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.TimelinessDashboardProcessPhaseRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/timelinessDashboard/batchProcessPhaseSend`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
